import ProjectType from './ProjectType';
import Client from './Client';
import State from './State';
import County from './County';
import { LandSystem } from './LandSystem';
import { Tag } from 'react-tag-autocomplete';
import { OwnershipCategoryType } from './OwnershipCategory';

export default class Project {
    public id: number;
    public name: string;
    public cloakName: string;
    public isShadow: boolean;
    public isRealVisible: boolean;
    public client: Client;
    public projectNumber: number;
    public cloakProjectNumber: number;
    public projectType: ProjectType;
    public state: State;
    public counties: Array<County>;
    public addCounties: Array<County>;
    public deleteCounties: Array<County>;
    public managingOfficeId: number;
    public landSystemId: LandSystem;
    public companyOwnerLookUpId: number;
    public clientOwnerLookUpId: number;
    public defaultOwnerLookUpId: number;
    public updateNeeded: boolean;
    public pcapmId: number;
    public projectBillingId?: number;
    public projectDetailsId?: number;
    public tractTypeId?: number;
    public tractTypeName: string;
    public tags: Array<Tag>;
    public ownershipCategoryTypes: Array<OwnershipCategoryType>;
    public isCommittedCategoriesHidden: boolean;

    // not mapped
    public isFavorite?: boolean;
}



// WEBPACK FOOTER //
// ./src/models/Project.ts